import React, { useState, useEffect } from 'react';
import { ChevronDown, Instagram, Mail, Phone, Star, ArrowRight, Menu, X, ShoppingBag } from 'lucide-react';
import { FilloutSliderEmbed, FilloutFullScreenEmbed } from '@fillout/react';
// Remove this problematic import
// import '@fillout/react/style.css';
import meetKeara from '../assets/meetKeara.png'; // Placeholder for Keara's image
import ImageStyleAnalyzer from '../components/ImageStyleAnalyzer';

const StylingWebsite = () => {
  const [activePackage, setActivePackage] = useState(null);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [filloutOpen, setFilloutOpen] = useState(false);

  const testimonials = [
    {
      name: "Sarah Mitchell",
      text: "Keara transformed not just my closet, but my entire relationship with fashion. I finally feel confident in my own skin.",
      rating: 5
    },
    {
      name: "Jessica Chen",
      text: "The investment was worth every penny. My morning routine is now effortless, and I love everything in my wardrobe.",
      rating: 5
    },
    {
      name: "Maria Rodriguez",
      text: "Keara has an incredible eye for what works. She helped me find my personal style in a way that feels authentic and elegant.",
      rating: 5
    }
  ];

  // Auto-scroll testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const packages = [
    {
      title: "Style Snack",
      price: "$75",
      duration: "One-time service",
      description: "In need of one outfit for a specific event",
      includes: [
        "Personalized outfit consultation",
        "Complete look for your specific event",
        "Styling tips and recommendations",
        "Shopping links for all items",
        "Alternative options within budget"
      ]
    },
    {
      title: "Clean Slate",
      price: "$359",
      duration: "Comprehensive styling",
      description: "15 pieces that will work with what is already in your closet and help you curate endless looks",
      bonus: "+$50 will get you an outfit building cheat sheet",
      includes: [
        "Closet assessment questionnaire",
        "15 carefully selected pieces",
        "Styling tips for each piece",
        "Optional: Outfit building cheat sheet (+$50)"
      ]
    },
    {
      title: "Seasonal Set Up",
      price: "$849",
      duration: "Complete wardrobe refresh",
      description: "Style overhaul, delivering 35 unique pieces to set your wardrobe up for success! This tier also allows for 2 weeks of unlimited messaging with me.",
      bonus: "+$100 Outfit combinations guide",
      includes: [
        "Closet assessment questionnaire",
        "35 handpicked pieces for the season",
        "2 weeks of unlimited messaging support",
        "Personalized shopping list",
        "Style maintenance tips"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-stone-50 overflow-x-hidden">
      {/* Fillout Slider Form */}
      <FilloutSliderEmbed
        filloutId="xcJSAUvV2Tus"
        isOpen={filloutOpen}
        onClose={() => setFilloutOpen(false)}
        sliderDirection="right"
        size="medium"
        inheritParameters
      />

      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-md z-50 border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-6">
          {/* Desktop Navigation */}
          <div className="hidden md:flex flex-col items-center space-y-5">
            {/* Logo */}
            <div className="text-3xl lg:text-4xl font-black text-gray-900 tracking-[0.2em] lg:tracking-[0.3em]">
              kearaeliz
            </div>
            
            {/* <div className="flex flex-wrap justify-center gap-6 lg:gap-10 text-gray-600">
              <a href="#about" className="hover:text-gray-900 transition-colors text-xs lg:text-sm uppercase tracking-[0.15em] lg:tracking-[0.2em] font-light">About</a>
              <a href="#services" className="hover:text-gray-900 transition-colors text-xs lg:text-sm uppercase tracking-[0.15em] lg:tracking-[0.2em] font-light">Services</a>
              <a href="#testimonials" className="hover:text-gray-900 transition-colors text-xs lg:text-sm uppercase tracking-[0.15em] lg:tracking-[0.2em] font-light">Testimonials</a>
              <a href="#" className="hover:text-gray-900 transition-colors text-xs lg:text-sm uppercase tracking-[0.15em] lg:tracking-[0.2em] font-light">Portfolio</a>
              <a href="#" className="hover:text-gray-900 transition-colors text-xs lg:text-sm uppercase tracking-[0.15em] lg:tracking-[0.2em] font-light">Blog</a>
              <a href="#" className="hover:text-gray-900 transition-colors text-xs lg:text-sm uppercase tracking-[0.15em] lg:tracking-[0.2em] font-light">Shop</a>
              <a href="#contact" className="hover:text-gray-900 transition-colors text-xs lg:text-sm uppercase tracking-[0.15em] lg:tracking-[0.2em] font-light">Contact</a>
            </div> */}
          </div>

          {/* Mobile Navigation */}
          <div className="md:hidden flex justify-between items-center">
            <div className="text-xl sm:text-2xl font-black text-gray-900 tracking-[0.15em] sm:tracking-[0.2em]">
              kearaeliz
            </div>
            {/* <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-gray-600 hover:text-gray-900 transition-colors p-2"
            >
              {mobileMenuOpen ? <X className="w-5 h-5 sm:w-6 sm:h-6" /> : <Menu className="w-5 h-5 sm:w-6 sm:h-6" />}
            </button> */}
          </div>

          {/* {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 border-t border-stone-200">
              <div className="flex flex-col space-y-3 pt-4">
                <a href="#about" onClick={() => setMobileMenuOpen(false)} className="text-gray-600 hover:text-gray-900 transition-colors text-xs uppercase tracking-[0.15em] font-light text-center py-2">About</a>
                <a href="#services" onClick={() => setMobileMenuOpen(false)} className="text-gray-600 hover:text-gray-900 transition-colors text-xs uppercase tracking-[0.15em] font-light text-center py-2">Services</a>
                <a href="#testimonials" onClick={() => setMobileMenuOpen(false)} className="text-gray-600 hover:text-gray-900 transition-colors text-xs uppercase tracking-[0.15em] font-light text-center py-2">Testimonials</a>
                <a href="#" onClick={() => setMobileMenuOpen(false)} className="text-gray-600 hover:text-gray-900 transition-colors text-xs uppercase tracking-[0.15em] font-light text-center py-2">Portfolio</a>
                <a href="#" onClick={() => setMobileMenuOpen(false)} className="text-gray-600 hover:text-gray-900 transition-colors text-xs uppercase tracking-[0.15em] font-light text-center py-2">Blog</a>
                <a href="#" onClick={() => setMobileMenuOpen(false)} className="text-gray-600 hover:text-gray-900 transition-colors text-xs uppercase tracking-[0.15em] font-light text-center py-2">Shop</a>
                <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="text-gray-600 hover:text-gray-900 transition-colors text-xs uppercase tracking-[0.15em] font-light text-center py-2">Contact</a>
              </div>
            </div>
          )} */}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-24 sm:pt-28 md:pt-40 pb-12 sm:pb-16 px-4 sm:px-6 bg-gradient-to-br from-stone-50 to-stone-100">
        <div className="max-w-5xl mx-auto">
          <div className="text-center min-h-[60vh] sm:min-h-[70vh] md:min-h-[85vh] flex flex-col justify-center">
            <div className="space-y-6 sm:space-y-8 md:space-y-10 lg:space-y-14">
              <h1 className="text-5xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light text-gray-900 leading-[1.2] tracking-wide">
                kearated
                <span className="italic text-amber-800 font-normal block sm:inline"> by kearaeliz </span>
              </h1>
              <p className="text-xl sm:text-xl md:text-2xl lg:text-3xl text-gray-700 leading-relaxed max-w-xl sm:max-w-2xl lg:max-w-4xl mx-auto font-light tracking-wide px-4">
                styling services perfectly curated.
              </p>
              <div className="flex justify-center pt-2 sm:pt-4 md:pt-10">
                <button 
                  onClick={() => setFilloutOpen(true)}
                  className="bg-gray-900 text-white px-6 py-3 sm:px-8 sm:py-4 md:px-12 md:py-6 rounded-sm hover:bg-gray-800 transition-all duration-300 flex items-center space-x-2 sm:space-x-3 group hover:scale-105 shadow-lg"
                >
                  <span className="text-xs sm:text-sm md:text-lg font-light tracking-[0.1em] uppercase">Work with me</span>
                  <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="py-20 bg-stone-100">
  <div className="max-w-5xl mx-auto px-4 sm:px-6">
    <ImageStyleAnalyzer />
  </div>
</section> */}


      {/* Social Links Section */}
      <section className="py-12 sm:py-16 bg-stone-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center">
            <h3 className="text-lg sm:text-xl md:text-2xl font-light text-gray-900 mb-6 sm:mb-8 tracking-[0.15em] uppercase">Find me here</h3>
            <div className="flex justify-center items-center space-x-6 sm:space-x-8 md:space-x-12">
              <a 
                href="https://instagram.com/kearaeliz" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group"
              >
                <div className="flex flex-col items-center space-y-2 md:space-y-3">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-full border-2 border-stone-300 flex items-center justify-center group-hover:border-amber-700 transition-all duration-300 group-hover:scale-110">
                    <Instagram className="w-5 h-5 md:w-6 md:h-6 text-gray-700 group-hover:text-amber-700 transition-colors" />
                  </div>
                  <span className="text-[10px] sm:text-xs uppercase tracking-[0.1em] text-gray-600 font-light">Instagram</span>
                </div>
              </a>
              
              
              <a 
                href="https://shopmy.us/kearaelizabeth" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group"
              >
                <div className="flex flex-col items-center space-y-2 md:space-y-3">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-full border-2 border-stone-300 flex items-center justify-center group-hover:border-amber-700 transition-all duration-300 group-hover:scale-110">
                    <ShoppingBag className="w-5 h-5 md:w-6 md:h-6 text-gray-700 group-hover:text-amber-700 transition-colors" />
                  </div>
                  <span className="text-[10px] sm:text-xs uppercase tracking-[0.1em] text-gray-600 font-light">ShopMy</span>
                </div>
              </a>
              
              <a 
                href="https://kearaeliz.substack.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group"
              >
                <div className="flex flex-col items-center space-y-2 md:space-y-3">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-full border-2 border-stone-300 flex items-center justify-center group-hover:border-amber-700 transition-all duration-300 group-hover:scale-110">
                    <Mail className="w-5 h-5 md:w-6 md:h-6 text-gray-700 group-hover:text-amber-700 transition-colors" />
                  </div>
                  <span className="text-[10px] sm:text-xs uppercase tracking-[0.1em] text-gray-600 font-light">Substack</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-16 sm:py-20 md:py-24 bg-stone-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16 md:mb-20">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-gray-900 mb-6 sm:mb-8 tracking-wide">Meet Keara</h2>
            <div className="w-24 sm:w-32 h-px bg-amber-700 mx-auto mb-8 sm:mb-10"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12 md:gap-16 items-start">
            <div className="md:col-span-2 space-y-6 sm:space-y-8 text-gray-800 leading-relaxed order-2 md:order-1">
            <p className="text-base sm:text-lg md:text-xl tracking-wide italic text-amber-800 font-normal block sm:inline">
              Unique styling services to help you achieve your best look yet.  
              </p>
              <p className="text-base sm:text-lg md:text-xl font-light tracking-wide">
              Using a simple and refined approach, Keara will help identify your specific style 
              needs and build a wardrobe that works for your lifestyle.
              </p>
              <p className="text-base sm:text-lg md:text-xl font-light tracking-wide">
              As a brand strategist with 5+ years in the fashion and beauty industry, 
              Keara has an eye for emerging brands, quality trends, and seasonal selections.
              </p>
            </div>
            <div className="space-y-6 sm:space-y-8 order-1 md:order-2">
            <div className="aspect-square rounded-sm shadow-lg overflow-hidden max-w-xs mx-auto md:max-w-none">
              <img src={meetKeara} alt="Meet Keara" className="w-full h-full object-cover" />
            </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-16 sm:py-20 md:py-24 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16 md:mb-20">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-gray-900 mb-6 sm:mb-8 tracking-wide">Services & Packages</h2>
            <div className="w-24 sm:w-32 h-px bg-amber-700 mx-auto mb-8 sm:mb-10"></div>
            <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto font-light tracking-wide leading-relaxed px-4">
              Thoughtfully designed experiences to help you build a wardrobe you'll love
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10">
            {packages.map((pkg, index) => (
              <div
                key={index}
                className="bg-white rounded-lg border-2 border-stone-200 p-6 sm:p-8 lg:p-10 shadow-xl hover:shadow-2xl hover:border-stone-300 transition-all duration-300 cursor-pointer transform hover:-translate-y-2"
                onClick={() => setActivePackage(activePackage === index ? null : index)}
              >
                <div className="text-center mb-6 sm:mb-8">
                  <h3 className="text-xl sm:text-2xl lg:text-3xl font-light text-gray-900 mb-3 sm:mb-4 tracking-wide">{pkg.title}</h3>
                  <div className="text-3xl sm:text-4xl font-light text-gray-800 mb-2 sm:mb-3 tracking-wide">{pkg.price}</div>
                  <div className="text-xs sm:text-sm text-gray-600 font-light tracking-[0.1em] uppercase">{pkg.duration}</div>
                </div>
                
                <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 leading-relaxed font-light tracking-wide text-center">{pkg.description}</p>
                
                {pkg.bonus && (
                  <p className="text-xs sm:text-sm text-amber-700 mb-4 sm:mb-6 text-center font-medium">
                    {pkg.bonus}
                  </p>
                )}
                
                <div className="space-y-3 sm:space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="text-xs sm:text-sm font-normal text-gray-800 tracking-[0.1em] uppercase">What's included</span>
                    <ChevronDown 
                      className={`w-4 h-4 text-gray-600 transition-transform ${
                        activePackage === index ? 'rotate-180' : ''
                      }`} 
                    />
                  </div>
                  
                  {activePackage === index && (
                    <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-gray-700 font-light">
                      {pkg.includes.map((item, i) => (
                        <li key={i} className="flex items-start space-x-3">
                          <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-amber-600 rounded-full mt-1.5 sm:mt-2 flex-shrink-0"></div>
                          <span className="tracking-wide">{item}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    setFilloutOpen(true);
                  }}
                  className="w-full mt-6 sm:mt-8 border-2 border-stone-300 text-gray-800 py-3 sm:py-4 rounded-lg hover:bg-gray-900 hover:text-white hover:border-gray-900 transition-all duration-300 font-light tracking-[0.1em] uppercase text-xs sm:text-sm"
                >
                  Book This Service
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-16 sm:py-20 md:py-24 bg-stone-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-gray-900 mb-6 sm:mb-8 tracking-wide">Stay In Style</h2>
          <div className="w-24 sm:w-32 h-px bg-amber-700 mx-auto mb-8 sm:mb-10"></div>
          <p className="text-base sm:text-lg md:text-xl text-gray-800 mb-12 sm:mb-16 max-w-3xl mx-auto font-light tracking-wide leading-relaxed px-4">
            Get weekly style insights, seasonal wardrobe tips, and exclusive styling advice 
            delivered to your inbox.
          </p>
          
          <div className="flex justify-center">
            <div className="bg-white p-4 sm:p-6 md:p-10 rounded-sm shadow-xl border border-stone-300 w-full max-w-[320px] sm:max-w-[480px]">
              <iframe 
                src="https://kearaeliz.substack.com/embed" 
                width="100%" 
                height="320" 
                style={{border: "1px solid #d6d3d1", background: "white", maxWidth: "100%"}} 
                frameBorder="0" 
                scrolling="no"
                className="rounded-sm"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 sm:py-20 md:py-24 bg-gray-900 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-light mb-6 sm:mb-8 tracking-wide">Ready to Transform Your Style?</h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-12 sm:mb-16 max-w-3xl mx-auto font-light tracking-wide leading-relaxed px-4">
            Let's work together to create a wardrobe that makes you feel confident, 
            authentic, and effortlessly elegant every day.
          </p>
          
          
          <button 
            onClick={() => setFilloutOpen(true)}
            className="bg-white text-gray-900 px-6 py-3 sm:px-8 sm:py-4 md:px-10 md:py-5 rounded-sm hover:bg-stone-100 transition-all duration-300 font-light tracking-[0.1em] uppercase shadow-lg hover:scale-105 text-xs sm:text-sm"
          >
            Schedule Your Free Consultation
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-950 text-gray-400 py-8 sm:py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">
          <div className="text-xl sm:text-2xl font-light text-gray-200 mb-3 sm:mb-4 tracking-[0.15em] sm:tracking-[0.2em]">kearaeliz</div>
          <p className="text-xs sm:text-sm font-light tracking-wide">© 2025 Kearaeliz. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default StylingWebsite;